<template>
  <div class="grid-x grid-padding-x align-middle contentContainer">
    <div class="cell small-12 contentPosition">
      <h1>404: Oops!<br/>
        I'm afraid we can't find the page you're looking for.</h1>
      <rare-standard-button
        class="contactButton show-for-small-only"
        :active="'true'"
        :buttonText="'Get in touch'"
        :height="'40px'"
        :width="'160px'"
        :fontColor="'#ffffff'"
        :fontSize="'12px'"
        @clicked="openContactForm"
      />
      <rare-standard-button
        class="contactButton show-for-medium"
        :buttonText="'Get in touch'"
        :height="'64px'"
        :width="'282px'"
        :fontColor="'#ffffff'"
        :fontSize="'16px'"
        @clicked="openContactForm"
      />

    </div>
  </div>

</template>

<script>

import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'Rare404HeaderContents',
  components: {
    'rare-standard-button': RareStandardButton,
  },
  methods: {
    openContactForm() {
      this.$root.$emit('updateContactForm', true);
    },
  },
};
</script>

<style scoped>

  .contentContainer {
    height: 100%;
  }

  h1 {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  @media only screen and (max-width: 640px)  {
    .contentPosition {
      padding-left: 6%;
      padding-right: 6%;
    }

    .contactButton {
      margin-top: 10px;
    }

    h1 {
      font-size: 32px;
      line-height: 1.25;
      letter-spacing: 0.4px;
      padding-top: 35px;
    }
  }

  @media only screen and (min-width: 641px) and (max-width: 1049px)  {
    .contentPosition {
      padding-left: 9%;
      padding-right: 9%;
      padding-top: 8%;
    }

    .contactButton {
      margin-top: 20px;
    }


  }

  @media only screen and (min-width: 1050px)  {
    .contentPosition {
      padding-left: 16%;
      padding-right: 16%;
    }

    .contactButton {
      margin-top: 40px;
    }

    h1 {
      font-size: 64px;
      line-height: 1.25;
      letter-spacing: 0.8px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/errorNotFound/components/Rare404HeaderContents.vue